import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Box from 'Common/Box/Box';

import DoneIcon from '@material-ui/icons/Done';
import CircularProgress from '@material-ui/core/CircularProgress';

import { commonColors } from '../../commonColors';

const useStyle = makeStyles((theme) => {
  return {
    statusBarItem: {
      margin: '0.5rem',
      padding: '0.5rem',
      color: theme.palette.text.primary,
      // @ts-ignore
      background: theme.palette.background.semilight,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    successIcon: {
      colorPrimary: commonColors.green500,
    },
  };
});

export const StatusBarItem: React.FC<{
  show: boolean;
  text: string;
  tooltip: string;
  testId?: string;
}> = ({ show, text, tooltip, testId }) => {
  const [display, setDisplay] = useState(false);
  const [displayDoneIcon, setDisplayDoneIcon] = useState(false);

  const classes = useStyle();

  useEffect(() => {
    let timerId = 0;

    if (show) {
      setDisplay(true);
    }

    if (show === false) {
      setDisplayDoneIcon(true);

      timerId = window.setTimeout(() => {
        setDisplay(false);
        setDisplayDoneIcon(false);
      }, 1000);
    }

    return () => {
      clearTimeout(timerId);
      setDisplayDoneIcon(false);
    };
  }, [show]);

  if (display) {
    return (
      // @ts-ignore
      <Box className={classes.statusBarItem} title={tooltip} data-testid={testId}>
        {text}
        {displayDoneIcon ? (
          // @ts-ignore
          <DoneIcon color="primary" className={classes.successIcon} size={20} />
        ) : (
          <CircularProgress color="secondary" size={20} disableShrink={true} />
        )}
      </Box>
    );
  }

  return null;
};
